export default {
  path: '/qualities',
  name: 'qualities',
  component: () => import('../components/quality/Layout'),
  redirect: { name: 'QualityList' },
  meta: {
    breadcrumb: 'profile.quality.qualities',
  },
  children: [
    {
      name: 'QualityList',
      path: '',
      component: () => import('../views/quality/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'QualityCreate',
      path: 'new',
      component: () => import('../views/quality/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'QualityUpdate',
      path: ':id/edit',
      component: () => import('../views/quality/Update'),
      meta: {
        breadcrumb: 'profile.quality.quality',
      },
    },
    {
      name: 'QualityShow',
      path: ':id',
      component: () => import('../views/quality/Show'),
      meta: {
        breadcrumb: 'profile.quality.quality',
      },
    }
  ]
};
